// Firebase email-action links (password reset, email verification, email
// recovery) carry a one-time `oobCode` in the query string. The router renders
// <AuthAction> for them, and every tracker must stay silent while such a query
// is present so the code never reaches GA4, Google Ads or Meta in a page URL.
export const AUTH_ACTION_MODES = Object.freeze(['resetPassword', 'verifyEmail', 'recoverEmail']);

export const hasAuthActionQuery = (search = '') => {
  try {
    const params = new URLSearchParams(search);
    return Boolean(
      params.get('oobCode')
      && AUTH_ACTION_MODES.includes(params.get('mode'))
    );
  } catch {
    return false;
  }
};

export const isAuthActionUrlActive = () => {
  if (typeof window === 'undefined') return false;
  try {
    return hasAuthActionQuery(window.location?.search || '');
  } catch {
    return false;
  }
};
